import { render, staticRenderFns } from "./ComplaintListItem.vue?vue&type=template&id=342e6aee"
import script from "./ComplaintListItem.vue?vue&type=script&lang=js"
export * from "./ComplaintListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports